/* eslint-disable no-undef */
import * as Sentry from '@sentry/browser';
import { Integrations } from '@sentry/tracing';
import LogRocket from 'logrocket';

const env = process.env.ENVIRONMENT || 'local';

let envApiUrl = '';
let envBaseUrl = '';

if (env === 'prod') {
  envApiUrl = `${process.env.REACT_APP_DOMAIN_PROD}/api/v2`;
  envBaseUrl = process.env.REACT_APP_DOMAIN_PROD;
} else if (env === 'stage') {
  envApiUrl = `${process.env.REACT_APP_DOMAIN_STAG}/api/v2`;
  envBaseUrl = process.env.REACT_APP_DOMAIN_STAG;
} else if (env === 'dev') {
  envApiUrl = `${process.env.REACT_APP_DOMAIN_DEV}/api/v2`;
  envBaseUrl = process.env.REACT_APP_DOMAIN_DEV;
} else {
  envApiUrl = `${process.env.REACT_APP_DOMAIN_LOCAL}/api/v2`;
  envBaseUrl = process.env.REACT_APP_DOMAIN_LOCAL;
}

if (env !== 'local') {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    environment: process.env.ENVIRONMENT,
    integrations: [new Integrations.Tracing()],
    tracesSampleRate: 1.0,
  });

  Sentry.configureScope((scope) => {
    scope.setUser({ id: localStorage.getItem('userId') });
  });

  if (env === 'prod') {
    LogRocket.init(process.env.REACT_APP_LOG_ROCKET_ID, {
      dom: {
        inputSanitizer: true,
      },
      network: {
        requestSanitizer: (request) => {
          // scrub header value from request
          if (request.headers.Authorization) {
            request.headers.Authorization = '';
          }
          return request;
        },
      },
    });
    LogRocket.getSessionURL((sessionURL) => {
      Sentry.configureScope((scope) => {
        scope.setExtra('sessionURL', sessionURL);
      });
    });
  }
}
const apiUrl = envApiUrl;
const baseUrl = envBaseUrl;
export { baseUrl };
export default apiUrl;
